import { ServiceMaker, methods, services } from "./index";

/**
 * Admin
 * Tenant
 * Partner
 */

/**
 * SECTION UPDATE
 * 
 * Admin Update:
 *     URL: {{BASE_URL}}/cap/users/admin/update/{id}
 *     ```
 *     {
 *          "name": {
 *              "first": "Shanti",
 *              "last": "Roy"
 *          },
 *          "authentication": {
 *              "email": "roy.shantinath@gmail.com",
 *              "userName": "shanti",
 *              "password": "123456"
 *          },
 *          "category": "TechAdmin",
 *          "tenant": "5db4047f9d2fdf00145c108b"
 *      }
 *     ```
 * 
 * Tenant Update: 
 *     URL: {{BASE_URL}}/cap/users/tenant/{id}
 *     ```
 *     {
 *          "authentication": {
 *              "email": "foo@gmail.com",
 *              "password": "123456",
 *              "phone": "+919537122171",
 *              "userName": "foo"
 *          }
 *      }
 *     ```
 * 
 * Partner Update: 
 *     URL: {{BASE_URL}}/cap/users/partner/update/{id}
 *     ``` 
       {
           "authentication": {
               "securityQA": {
                   "question": "what is your first school",
                   "answer": "no"
               },
               "userName": "test",
               "phone": "9909199091",
               "email": "dfjdskf@gmail.com"
           },
           "office": {
               "address": {
                   "city": "Surat",
                   "country": "India",
                   "houseNumber": "50",
                   "state": "Gujarat",
                   "street": "Govardhan",
                   "zip": "394107"
               },
               "officeName": "Test partner office",
               "email": [
                   {
                       "_id": "5d1204cdd63b444987a8602a",
                       "mailId": "bhdsghj@gmail.com"
                   }
               ],
               "phone": [
                   {
                       "_id": "5d1204cdd63b444987a8602b",
                       "code": 1,
                       "number": 9909199091
                   }
               ]
           }
       }
 *     ```
 */

// export const myAddress = payload =>
//     serviceMaker(
//         "/cap/users/customer/me",
//         methods.GET,
//         ENDPOINT.AUTH_MICROSERVICE,
//         payload
//     );

// export const updateAddress = (id, payload) =>
//     serviceMaker(
//         `/cap/users/partner/update/${id}`,
//         methods.PUT,
//         ENDPOINT.AUTH_MICROSERVICE,
//         payload
//     );

const updateURL = {
  admin: "/users/admin/update",
  tenant: "/users/tenant/",
  partner: "/users/partner/update",
};

const myInfoURL = {
  admin: "/users/admin/me",
  tenant: "/users/partner/me",
  partner: "/users/partner/me",
};

const changePassword = {
  // "admin": '/users/admin/me',
  tenant: "/users/tenant/update-password",
  partner: "/users/partner/update-password",
};
export const updateUser = (type, id, data) =>
  ServiceMaker(`${updateURL[type]}/${id}`, methods.PUT, services.nipige, data);
export const meInfo = (type) =>
  ServiceMaker(myInfoURL[type], methods.GET, services.nipige);
export const passwordUpdate = (type, data) =>
  ServiceMaker(changePassword[type], methods.POST, services.nipige, data);
